/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBadgeDown = createReactComponent("outline", "arrow-badge-down", "IconArrowBadgeDown", [["path", { "d": "M17 13v-6l-5 4l-5 -4v6l5 4z", "key": "svg-0" }]]);

export { IconArrowBadgeDown as default };
//# sourceMappingURL=IconArrowBadgeDown.mjs.map
